const isOwnedAction = (action, ownedActions) =>
  ownedActions.some(ownedAction => ownedAction.id === action);

export default isOwnedAction;
